import React from 'react';
import './YesNoStatistic.css';

const YesNoStatistic = ({ post, color }) => {
    const yesCount = post.question.questions[0].reviews.length;
    const noCount = post.question.questions[1].reviews.length;
    const lineWidth = yesCount + noCount === 0 ? 0 : (noCount * 100) / (yesCount + noCount);
    return (
        <div className={'yes-no-statistic'}>
            <span className={lineWidth >= 50 && 'activeText'}>{noCount}</span>
            <div className={`yes-no-button ${lineWidth >= 50 && 'active'}`}>NO</div>
            <div className={'statistic-line'}>
                <div
                    style={{
                        width: `${lineWidth}%`,
                        backgroundColor: `${color}`,
                        height: '100%',
                    }}
                />
            </div>
            <div className={`yes-no-button ${lineWidth <= 50 && 'active'}`}>YES</div>
            <span className={lineWidth <= 50 && 'activeText'}>{yesCount}</span>
        </div>
    );
};

export default YesNoStatistic;
